export const QUERIES_TO_REFETCH_AFTER_CHANGE = [
  'UpcomingPayments',
  'AggregateUpcomingPayments',
  'AggregateTransactions',
];
